import api from "@/modules/shared/api/axios";
import { downloadBlob } from "@/utils/mobileShell";

export const fetchWallet = async () => {
  const response = await api.get("/wallet", { forceRefresh: true });
  return response.data?.data;
};

export const fetchWalletTransactions = async (page, perPage = 15) => {
  const response = await api.get("/wallet/transactions", {
    params: { page, per_page: perPage },
    forceRefresh: true,
  });
  return response.data;
};

export const fetchWalletRechargeOptions = async () => {
  const response = await api.get("/wallet/recharge-options", { forceRefresh: true });
  return response.data?.data;
};

export const createWalletRechargeCheckout = async (optionId, method) => {
  const response = await api.post('/wallet/recharges/checkout', { option_id: optionId, method });
  return response.data?.data;
};

export const simulateWalletRechargePayment = async (optionId, method) => {
  const response = await api.post("/wallet/recharges/simulate", { option_id: optionId, method });
  return response.data;
};

export const createWalletSadadInvoice = async (optionId) => {
  const response = await api.post("/wallet/recharges/sadad", { option_id: optionId });
  return response.data?.data;
};

export const submitWalletBankTransfer = async (optionId, paymentSlip) => {
  const body = new FormData();
  body.append('option_id', optionId);
  body.append('payment_slip', paymentSlip);
  const response = await api.post('/wallet/recharges/bank-transfer', body);
  return response.data?.data;
};

export const verifyWalletRecharge = async (orderId, resourcePath) => {
  const response = await api.post(`/wallet/recharges/${orderId}/status`, { resourcePath });
  return response.data?.data;
};

// Invoices are served only through the authenticated download endpoint, never by direct link.
export const downloadWalletInvoice = async (invoiceUrl) => {
  const fileName = invoiceUrl.split("/").pop();
  const response = await api.get(`/invoices/download/${encodeURIComponent(fileName)}`, {
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  });
  const mimeType = response.headers?.["content-type"] || "application/pdf";
  await downloadBlob(new Blob([response.data], { type: mimeType }), fileName, { mimeType, previewable: true });
};
